import { useNavigate } from "react-router-dom"

const BestSellers = ({product, mocktails}) => {
    const navigate = useNavigate()


    return (
        <div className=" col-md-4 d-flex justify-content-center align-items-center" >


                <div className={`tt-bestsellers-img-container d-flex flex-column justify-content-center align-items-center border border-2 border-dark rounded-2  `} style={{boxShadow: `10px 10px ${product.color}`}} onClick={() => navigate(`/products/${product.id}`)}>
                    <h3 className="d-flex justify-content-center align-items-center text-center fw-bold text-dark p-2 m-0">{product.name}</h3>
                    <img src={product.img_main} className="tt-bestsellers-img img-fluid py-2" alt="" />
                    {/* <p className="text-center">{product.type}</p> */}
                </div>


            

        </div>
        // <div className=" col-md-4 d-flex flex-column justify-content-center align-items-center" >
        //     <div className={`tt-bestsellers-img-container d-flex flex-column justify-content-center align-items-center border border-2 border-dark rounded-2 p-5 w-100`} style={{boxShadow: `10px 10px ${product.color}`, backgroundColor: product.bgcolor}} onClick={() => navigate(`/products/${product.id}`)}>
        //         <h3 className="d-flex justify-content-center align-items-center text-center fw-bold text-dark p-0 m-0">{product.name}</h3>
        //         <img src={product.img_main} className="tt-bestsellers-img img-fluid py-2" alt="" />
        //         <p className="text-center">{product.type}</p>
        //     </div>
        // </div>
    )
}

export default BestSellers